{"id":"ProductDetail.Gallery","prefabs":{"default":{"children":[{"component":"ProductDetail.Gallery","options":"options:*"}]}}}